module.exports = __webpack_public_path__ + "img/6.1266dad9.png";